// proposalFilter.slice.ts
import { IFilterModel } from '@common/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: { [page: string]: IFilterModel } = {
  users: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  },
  providers: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  },
  persons: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  },
  businessPartner: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  },
  proposal: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  },
  monthClosing: {
    namedFilters: {
      type: [],
      closingMonth: [],
      closingDate: []
    },
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  },
  policy: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  },
  transferLinks: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: '',
    descending: true
  },
  amendmentCancellationInsuredDetails: {
    namedFilters: {},
    pagination: {
      pageSize: 5,
      pageNumber: 1
    },
    orderBy: '',
    descending: true
  },
  medicalGroupInsuredDetails: {
    namedFilters: {},
    pagination: {
      pageSize: 5,
      pageNumber: 1
    },
    orderBy: 'policy.policyNumber',
    descending: false
  },
  transfer: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  },
  productionDistribution: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'policyNumber',
    descending: true
  },
  currencyExchangeRate: {
    namedFilters: {},
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'effectiveDate',
    descending: true
  },
  accountingClaims: {
    searchKey: '',
    namedFilters: {
      status: ['NOT_DUE', 'DUE']
    },
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'referenceNumber',
    descending: true
  },
  automationTesting: {
    searchKey: '',
    namedFilters: {
      type: [],
      status: [],
      runningDate: []
    },
    pagination: {
      pageSize: 10,
      pageNumber: 1
    },
    orderBy: 'createdOn',
    descending: true
  }
};

const filterStateSlice = createSlice({
  name: 'filterStateSlice',
  initialState,
  reducers: {
    setFilter(
      state,
      action: PayloadAction<{ page: string; filter: IFilterModel }>
    ) {
      state[action.payload.page] = action.payload.filter;
    },
    setNamedFilters(
      state,
      action: PayloadAction<{ page: string; namedFilters: Record<string, any> }>
    ) {
      if (!state[action.payload.page]) return;
      state[action.payload.page].namedFilters = {
        ...state[action.payload.page].namedFilters,
        ...action.payload.namedFilters
      };
    },
    setPagination(
      state,
      action: PayloadAction<{
        page: string;
        pagination: { pageNumber: number; pageSize: number };
      }>
    ) {
      if (!state[action.payload.page]) return;
      state[action.payload.page].pagination = action.payload.pagination;
    },
    setOrderBy(
      state,
      action: PayloadAction<{
        page: string;
        orderBy: string;
        descending: boolean;
      }>
    ) {
      if (!state[action.payload.page]) return;
      state[action.payload.page].orderBy = action.payload.orderBy;
      state[action.payload.page].descending = action.payload.descending;
    },
    resetFilters(state, action: PayloadAction<{ page: string }>) {
      if (initialState[action.payload.page]) {
        state[action.payload.page] = initialState[action.payload.page];
      } else {
        delete state[action.payload.page];
      }
    }
  }
});

export const {
  setFilter,
  setNamedFilters,
  setPagination,
  setOrderBy,
  resetFilters
} = filterStateSlice.actions;
const filterStateReducer = filterStateSlice.reducer;
export { filterStateReducer };
